export default __webpack_public_path__ + "static/media/GHA.bfe8b7d5.svg";